import { render, staticRenderFns } from "./NewPresentationFile.vue?vue&type=template&id=456d22bc&"
import script from "./NewPresentationFile.vue?vue&type=script&lang=js&"
export * from "./NewPresentationFile.vue?vue&type=script&lang=js&"
import style0 from "./NewPresentationFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports